import { ObservableArray, View } from "binder"
import { getAsNumber } from "src/uicomponents/components/utilities";
import { AttachmentListSelectorViewModel } from "../attachmentListSelector/attachmentListSelector-viewModel";
import { PersonSearchViewModel } from "../personSearch-viewModel";
import { CreateReceivableViewModel } from "./createReceivable-viewModel"
import { IGateway } from "./gateways/IGateway";

export class CreateReceivableView extends View<CreateReceivableViewModel>{
    GetViewUniqueId(): string {
        return "V-700C9584-EAD9-4D1C-ADCC-77DEB52FD749"
    }
    loadHtml(): string {
        let element = require('./createReceivable.html').default;
        let style = require('./createReceivable.less');
        return element;
    }
    constructor() {
       super();
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set personSelector(v: PersonSearchViewModel) { this._personSelector = v; } public get personSelector(): PersonSearchViewModel { return this._personSelector;} private _personSelector: PersonSearchViewModel;
    public set amount(v: number) { this._amount = getAsNumber(v,true); } public get amount(): number { return this._amount;} private _amount: number;
    public set time(v: moment.Moment) { this._time = v; } public get time(): moment.Moment { return this._time;} private _time: moment.Moment;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment;} private _comment: string;
    public set gateways(v: ObservableArray<IGateway>) { this._gateways = v; } public get gateways(): ObservableArray<IGateway> { return this._gateways;} private _gateways: ObservableArray<IGateway>;
    public set selectedGateway(v: IGateway) { this._selectedGateway = v; } public get selectedGateway(): IGateway { return this._selectedGateway;} private _selectedGateway: IGateway;
    public set selectedPersonName(v: string) { this._selectedPersonName = v; } public get selectedPersonName(): string { return this._selectedPersonName;} private _selectedPersonName: string;
    public set selectedPersonCode(v: string) { this._selectedPersonCode = v; } public get selectedPersonCode(): string { return this._selectedPersonCode;} private _selectedPersonCode: string;
    public set attachments(v: AttachmentListSelectorViewModel) { this._attachments = v; } public get attachments(): AttachmentListSelectorViewModel { return this._attachments;} private _attachments: AttachmentListSelectorViewModel;
    
    create(){
        this.dataContext.create();
    }
}
